import Portfolio from '@/types/portfolio';

/**
 * Gets Comparison Item Dates from a portfolio
 *
 * @param {Portfolio} portfolio Portfolio model object.
 * @return {ComparisonItemDates} Dates object based on the portfolio.
 */
export const getPortfolioDates = (portfolio: Portfolio) => {
  if (!portfolio.dates) return {};

  return {
    portfolioAllocations: portfolio.dates.allocations,
    portfolioGrowth: portfolio.dates.growth,
    portfolioHoldings: portfolio.dates.holdings,
    risk: portfolio.dates.risk,
    portfolioFixedIncomeSector: portfolio.dates.fixedIncomeSector,
    portfolioInvestmentInfo: portfolio.dates.investmentInfo,
    portfolioCharacteristics: portfolio.dates.characteristics,
    portfolioYieldToMaturity: portfolio.dates.yieldToMaturity,
    portfolioESGLatestHolding: portfolio.dates.esgLatestHolding,
    ...(portfolio.dates?.savedAt ? { savedAt: portfolio.dates.savedAt } : {}),
  };
};
